<router-outlet></router-outlet>
<app-loader *ngIf="isLoading"></app-loader>

<session-timeout></session-timeout>